module.exports = ".btn-chico-zoneAll {\n    color: #ffffff;\n    background-color: #ff7473;\n    padding: 9px 12px;\n    -webkit-transition: 0.2s all ease-in-out;\n    transition: 0.2s all ease-in-out;\n    margin-bottom: 0;\n  }\n  \n  .btn-chico-zoneAll:active,\n  .btn-chico-zoneAll:hover\n  {\n  background-color: #ff7473 !important;\n  color: #ffffff !important;\n  }"


//////////////////
// WEBPACK FOOTER
// ./src/app/components/school/school-view/school-view.component.css
// module id = ./src/app/components/school/school-view/school-view.component.css
// module chunks = main